import { render, staticRenderFns } from "./DeviceSetting.vue?vue&type=template&id=3b5f5830&scoped=true&"
import script from "./DeviceSetting.vue?vue&type=script&lang=js&"
export * from "./DeviceSetting.vue?vue&type=script&lang=js&"
import style0 from "./DeviceSetting.vue?vue&type=style&index=0&id=3b5f5830&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5f5830",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b5f5830')) {
      api.createRecord('3b5f5830', component.options)
    } else {
      api.reload('3b5f5830', component.options)
    }
    module.hot.accept("./DeviceSetting.vue?vue&type=template&id=3b5f5830&scoped=true&", function () {
      api.rerender('3b5f5830', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/DeviceSetting/coordi/DeviceSetting.vue"
export default component.exports